import { InAppMessageLayoutEvaluation } from "../../../../core/internal/evaluation/evalautor/iam/layout/InAppMessageLayoutEvaluation"
import {
  DecisionReason,
  HackleUser,
  InAppMessage,
  InAppMessageContextMessage,
  Properties
} from "../../../../core/internal/model/model"
import { InAppMessagePresentRequest } from "../InAppMessagePresentRequest"

export class InAppMessagePresentationContext {
  constructor(
    public readonly dispatchId: String,
    public readonly inAppMessage: InAppMessage,
    public readonly message: InAppMessageContextMessage,
    public readonly user: HackleUser,
    public readonly decisionReason: DecisionReason,
    public readonly properties: Properties
  ) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentationContext(dispatchId=${this.dispatchId}, inAppMessage=${this.inAppMessage}, message=${this.message})`
  }

  static of(request: InAppMessagePresentRequest): InAppMessagePresentationContext {
    return new InAppMessagePresentationContext(
      request.dispatchId,
      request.inAppMessage,
      request.message,
      request.user,
      request.reason,
      request.properties
    )
  }
}
